import React from 'react'
import styled from 'styled-components'

import { VerticalTableCalendar } from './vertical-table'

export const Calendar = (props) => {
  const {
    events,
    summary,
    publicHolidays,
  } = props

  return (
    <Root>
      <Content>
        <VerticalTableCalendar
          events={ events }
          summary={ summary }
          publicHolidays={ publicHolidays }
          teamCalendar={ true }
        />
      </Content>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;

  > * {
    display: flex;
  }
`
const Content = styled.div`
  height: 100%;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/calendar/index.js